import axios, { AxiosResponse } from "axios";
import { Parts } from "../models/parts";
import { PaginatedResult } from "../models/pagination";
import { requests } from "./Requests";
const responseBody = <T>(response: AxiosResponse<T>) => response.data;

export const PartApi = {
  listSearchParts: (params: URLSearchParams) =>
  axios
    .get<PaginatedResult<Parts[]>>(
      `/Parts/listParts`,
      { params }
    )
    .then(responseBody),
  addParts: (part: Parts) => requests.post<void>(`/Parts/addParts`, part),
  isPartInInventory: (params: URLSearchParams) => axios.get<PaginatedResult<boolean>>(`/Parts/partInInventory`,{ params }).then(responseBody),
};